import img205001 from "src/assets/images/kwaii/205001.png";
import img205002 from "src/assets/images/kwaii/205002.png";
import img205101 from "src/assets/images/kwaii/205101.png";

export default {
  205001: {
    name: "Common Field",
    description: "Used to grow 1 Plant",
    img: img205001,
    gen: 0,
  },
  205002: {
    name: "Grass Field",
    description: "Speed up 10% harvest time",
    img: img205002,
    gen: 0,
  },
  205101: {
    name: "Common Field",
    description: "Used to grow 1 Plant",
    img: img205101,
    gen: 1,
  },
};
